import React from "react";
import styles from "./RacketSkeleton.module.scss";

export const RacketSkeleton: React.FC = () => {
  return (
    <div className={styles.table_container}>
      {Array.from({ length: 17 }).map((_, index) => (
        <div key={index} className={styles.skeleton_item} />
      ))}
    </div>
  );
};

